// extracted by mini-css-extract-plugin
module.exports = {"container":"e_P8","title":"e_Q8","hiddenMobile":"e_R8"};